
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import errorService from "../../services/errorService";
import uiService from "@/services/uiService";
import ErrorCard from "@/components/partials/ErrorCard.vue";

export default Vue.extend({
  components: {
    ErrorCard,
  },
  data() {
    return {
      errorService,
      showNoti: false,
      binding: {},
      logo: '',
      error: "",
      hasBackRouter: "",
      title: "",
    };
  },
  watch: {
    $route: {
      handler() {
        this.title = this.$route.meta.title;
      },
      immediate: true
    }
  },
  computed: {
    optionNotification() {
      const options = {
        attrs: {
          class: 'noti-bottom'
        },
        content: {
          title: () => {
            return this.$t('LAYOUT.CONNECTIVITY_LOST');
          },
          html: () => {
            return this.errorService.normalize(this.error).err;
          },
        },
      };
      return options;
    },
  },
  async created() {
    await this.getClientSetting()
    msDataProvider.bindDataMany(["uiConfig"], this.binding, this, null, this);
  },
  methods: {
    openHelpCenter() {
      uiService.executeCommand('helpCenterShow');
    },
    errorHandler(err) {
      if (err === "") {
        this.error = ""
        this.showNoti = false
        return
      }
      this.error = err
      this.showNoti = true
    },
    async getClientSetting() {
      const res: any = await msDataProvider.getData("clientSetting")
      if (res && res.settings && res.settings.logo && res.settings.logo.main_logo) {
        this.logo = res.settings.logo.main_logo
      }
    },
    getImg() {
      if (this.logo) {
        return this.logo
      }
      return require('../../assets/images/MSuite-trang.svg')
    },
    async logout() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP"),
                title: this.$t("LAYOUT.LOGOUT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.LOGOUT"),
                iconOk: 'icon-logout-white24'
              },
              true
          )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
        sessionStorage.removeItem('userId');
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
